/**
 * Configuración de variables de entorno
 * Compatible con Windows y Linux
 */

const getEnvironmentConfig = () => {
  // Obtener variables de entorno
  const apiUrl = process.env.REACT_APP_API_URL;
  const cubeUrl = process.env.REACT_APP_CUBE_URL;
  const env = process.env.REACT_APP_ENV || process.env.NODE_ENV;

  // Configuración por defecto para desarrollo
  const defaultConfig = {
    development: {
      apiUrl: 'http://localhost:8000',
      cubeUrl: 'https://cubedev.technisupport.co'
    },
    production: {
      apiUrl: window.location.protocol + "//" + window.location.host,
      cubeUrl: 'https://cubedev.technisupport.co'
    },
    test: {
      apiUrl: window.location.protocol + "//" + window.location.host,
      cubeUrl: 'https://cubedev.technisupport.co'
    }
  };

  // Obtener configuración según el entorno
  const config = defaultConfig[env] || defaultConfig.development;

  // Usar variables de entorno si están definidas, sino usar configuración por defecto
  return {
    apiUrl: apiUrl || config.apiUrl,
    cubeUrl: cubeUrl || config.cubeUrl,
    env: env || 'development'
  };
};

// Función para validar que las URLs sean válidas
const validateUrl = (url) => {
  try {
    new URL(url);
    return true;
  } catch (error) {
    console.warn(`URL inválida: ${url}`);
    return false;
  }
};

// Función para obtener la URL base de la API
const getBaseUrl = () => {
  const config = getEnvironmentConfig();
  
  // Validar la URL antes de usarla
  if (!validateUrl(config.apiUrl)) {
    console.error('URL de API inválida, usando configuración por defecto');
    return 'http://localhost:8000';
  }
  
  return config.apiUrl;
};

// Función para obtener la URL base de Cube
const getCubeUrl = () => {
  const config = getEnvironmentConfig();
  
  // Validar la URL antes de usarla
  if (!validateUrl(config.cubeUrl)) {
    console.error('URL de Cube inválida, usando configuración por defecto');
    return 'https://cubedev.technisupport.co';
  }
  
  return config.cubeUrl;
};

// Función para obtener información del entorno actual
const getEnvironmentInfo = () => {
  const config = getEnvironmentConfig();
  
  return {
    ...config,
    isDevelopment: config.env === 'development',
    isProduction: config.env === 'production',
    isTest: config.env === 'test'
  };
};

export {
  getEnvironmentConfig,
  getBaseUrl,
  getCubeUrl,
  getEnvironmentInfo,
  validateUrl
};
